const mesureEnum = {
  /** AdjustmentHistory */
  ADJUSTMENTHISTORY_TOKENCREDITED: "AdjustmentHistory.tokencredited",
  ADJUSTMENTHISTORY_AMOUNT: "AdjustmentHistory.amount",
  ADJUSTMENTHISTORY_COUNT: "AdjustmentHistory.count",

  /** GameHistory */
  GAMEHISTORY_COUNT: "GameHistory.count",
  GAMEHISTORY_TOKEN: "GameHistory.token_quantity",
  /** Equivalent CA TTC calculé à partir du nombre de tokens et du prix d'un token */
  GAMEHISTORY_TOKEN_PRICE: "GameHistory.token_value_ttc",
  /** Equivalent CA HT calculé à partir du nombre de tokens, du prix d'un token et du taux de TVA */
  GAMEHISTORY_TOKEN_PRICE_HT: "GameHistory.token_value_ht",
  GAMEHISTORY_BONUSTOKEN: "GameHistory.bonustoken",
  GAMEHISTORY_BONUSTOKEN_PRICE_HT: "GameHistory.bonustoken_value_ht",
  GAMEHISTORY_TOKENHT: "GameHistory.tokenht",
  GAMEHISTORY_TOTALTOKEN: "GameHistory.totaltoken",
  GAMEHISTORY_TOTAL_VAT: "GameHistory.total_vat",

  /** PurchaseHistory */
  PURCHASEHISTORY_COUNT: "PurchaseHistory.count",
  PURCHASEHISTORY_COUNTSOLDCARDS: "PurchaseHistory.countsoldcards",
  PURCHASEHISTORY_TOKEN: "PurchaseHistory.token",
  PURCHASEHISTORY_BONUSTOKEN: "PurchaseHistory.bonustoken",
  PURCHASEHISTORY_AMOUNT: "PurchaseHistory.amount",
  PURCHASEHISTORY_AMOUNT_HT: "PurchaseHistory.amountht",
  PURCHASEHISTORY_AMOUNTCB: "PurchaseHistory.amountcb",
  PURCHASEHISTORY_AMOUNTCASH: "PurchaseHistory.amountcash",
  PURCHASEHISTORY_AMOUNT_5_PERCENT: "PurchaseHistory.amount5percent",
  PURCHASEHISTORY_AMOUNT_10_PERCENT: "PurchaseHistory.amount10percent",
  PURCHASEHISTORY_AMOUNT_20_PERCENT: "PurchaseHistory.amount20percent",

  /** SnackHistory */
  /** Nombre de tokens dépensés, hors paiements directs en CB */
  SNACKHISTORY_TOTALTOKEN_WITHOUTCB: "SnackHistory.totaltokenwithoutcb",
  /** Equivalent TTC du nombre de tokens dépensés, hors paiements directs en CB */
  SNACKHISTORY_EQUIVALENT_EURO_WITHOUTCB: "SnackHistory.equivalent_euro_without_cb",
  /** Equivalent CA TTC calculé à partir du nombre de tokens et du prix d'un token, des paiements en unités + paiements CB */
  SNACKHISTORY_TOKEN_PRICE: "SnackHistory.token_value_ttc",
  /** Equivalent CA HT calculé à partir du nombre de tokens, du prix d'un token et du taux de TVA, des paiements en unités + paiements CB */
  SNACKHISTORY_TOKEN_PRICE_HT: "SnackHistory.token_value_ht",
  /** Montant de paiement direct par CB, recalculé comme un équivalent CA TTC à partir du nombre de tokens, du prix d'un token et du taux de TVA */
  SNACKHISTORY_AMOUNT_CB_TTC: "SnackHistory.amount_cb_ttc",
  SNACKHISTORY_QUANTITY: "SnackHistory.quantity",
  SNACKHISTORY_TOTAL_VAT: "SnackHistory.total_vat",
  SNACKHISTORY_AMOUNT_5_PERCENT: "SnackHistory.amount_5_percent",
  SNACKHISTORY_AMOUNT_10_PERCENT: "SnackHistory.amount_10_percent",
  SNACKHISTORY_AMOUNT_20_PERCENT: "SnackHistory.amount_20_percent",

  /** StaffGameHistory */
  STAFFGAMEHISTORY_COUNT: "StaffGameHistory.count",
  STAFFGAMEHISTORY_TOKENCREDITED: "StaffGameHistory.tokencredited",
  STAFFGAMEHISTORY_REVENUE_EQUIVALENT_TTC: "StaffGameHistory.revenueequivalentttc",

  /** Recycling */
  RECYCLING_COUNT: "Recycling.count",

  /** AzureCost */
  AZURECOST_TRANSACTION_COUNT: "AzureCost.transactionCount",
  AZURECOST_EQUIVALENT_TRANSACTION: "AzureCost.equivalentTransaction",
  AZURECOST_PERCENT_TRANSACTION: "AzureCost.percentTransaction",
  AZURECOST_ELISA: "AzureCost.elisa",

  /** SmartTouch */
  SMARTTOUCH_COUNT: "SmartTouch.count",

  /** PurgeHistory */
  PURGEHISTORY_TOKEN: "PurgeHistory.BalanceTokens",
  PURGEHISTORY_FREE_TOKEN: "PurgeHistory.BalanceFreeTokens",
  PURGEHISTORY_TOKEN_PRICE: "PurgeHistory.TokenPrice",
  PURGEHISTORY_CA_GENERATED: "PurgeHistory.CAGenerated",

  /** vFullHourlyAccounting */
  VFULLHOURLYACCOUNTING_TOKENS: "vFullHourlyAccounting.tokens",
  VFULLHOURLYACCOUNTING_FREETOKENS: "vFullHourlyAccounting.freeTokens",
  VFULLHOURLYACCOUNTING_AMOUNT_TTC: "vFullHourlyAccounting.amountTtc",
  VFULLHOURLYACCOUNTING_AMOUNT_HT: "vFullHourlyAccounting.amountHt",
  VFULLHOURLYACCOUNTING_EXTRA_REVENUE: "vFullHourlyAccounting.extraRevenue",
  VFULLHOURLYACCOUNTING_EXTRA_REVENUE_HT: "vFullHourlyAccounting.extraRevenueHt",

  /** vAccountingRunningTotals */
  VACCOUNTINGRUNNINGTOTALS_RUNNINGTOTALTOKENS: "vAccountingRunningTotals.runningTotalTokens",
  VACCOUNTINGRUNNINGTOTALS_RUNNINGTOTALAMOUNT: "vAccountingRunningTotals.runningTotalAmount",

  /** SmartTouch */
  VSMARTTOUCHMAINTENANCE_DURATION_SUM: "vSmartTouchMaintenance.durationsum",
  VSMARTTOUCHMAINTENANCE_LAST_EVENT_DATE: "vSmartTouchMaintenance.lasteventdate",
  VSMARTTOUCHMAINTENANCE_LAST_END_OF_MAINTENANCE: "vSmartTouchMaintenance.lastendofmaintenance",

  /** OmniplayEvent */
  OMNIPLAYEVENT_NBCARDS: 'OmniplayEvent.NbCards',
  OMNIPLAYEVENT_TOTALTTC: 'OmniplayEvent.TotalTTC',
  OMNIPLAYEVENT_TOTALHT: 'OmniplayEvent.TotalHT',
  OMNIPLAYEVENT_NBCAKE: 'OmniplayEvent.NbCake',
  OMNIPLAYEVENT_TOTAL_BONUS_TOKEN: 'OmniplayEvent.TotalBonusToken'
};

export default mesureEnum;
